import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'post-form-modal',
  templateUrl: './post-form-modal.component.html',
  styleUrls: ['./post-form-modal.component.scss'],
  animations: [
    slide
  ]
})
export class PostFormModalComponent implements OnInit {
  @Input()  selectedPost: any;
  @Input()  forum: any;

  @Output() onHideFormModal = new EventEmitter<boolean>();

  post = {
    title: "",
    description: "",
    creatorName: "",
    creatorKey: "",
    commentTimestamp: 0
  };

  constructor(
    private dbService: DBService
  ) { }

  ngOnInit() {
    if (this.selectedPost) {
      this.post.title = this.selectedPost.title;
      this.post.description = this.selectedPost.description;
    }

  }

  onHideModal() {
    this.onHideFormModal.emit(true);
  }

  submitForm() {
    if (this.selectedPost) {
      this.dbService.updatePost(this.forum.$key, this.selectedPost.$key, this.post);
    } else {
      this.dbService.addPost(this.forum.$key, this.post);
    }

    this.onHideModal();
  }

}



// WEBPACK FOOTER //
// ./src/app/forums/post-form-modal/post-form-modal.component.ts